import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }
      

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
         const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
            text-align: left;           
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: center;          
        `

        const Color1 = styled.span`            
            color: #c1eb18;            
        `
        const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 50px;
            line-height: 50px;
            font-family: "Teko", sans-serif;
            font-weight: bold;
            color: #fff;
            text-align: center;
        `
        const Color3 = styled.span`          
          color: #c1eb18;
          font-family: "Teko", sans-serif;            
        `
        

        return(
          <Section>
            <ServiceContainer>
              <Container>
              <Heading2>Características de los <Color3>Servidores Privados Virtuales Administrados</Color3></Heading2>                

                <Text>
                  En el mundo de los Servidores VPS administrados, llevamos la gestión a un nivel superior al encargarnos completamente de la administración
                  del servidor, abarcando aspectos críticos de hardware y red. Este enfoque integral garantiza un rendimiento óptimo y una experiencia sin
                  preocupaciones para nuestros clientes. Desde la configuración inicial hasta las actualizaciones y el monitoreo continuo, nuestro equipo de
                  expertos se encarga de cada detalle, permitiendo a nuestros usuarios centrarse en sus proyectos sin distracciones técnicas. Con Servidores
                  VPS administrados, ofrecemos no solo un servicio, sino una solución completa que redefine la excelencia en el alojamiento web.
                </Text>

                <Row>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image1} alt="Gestión profesiona" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Gestión profesional continua
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          La clave distintiva de un VPS Administrado es la gestión continua por parte de expertos. Desde actualizaciones hasta monitoreo
                          de seguridad, cada detalle está en manos hábiles.<br></br><br></br>
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image2} alt="Soporte" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Soporte ininterrumpido 24/7
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Imagina tener un equipo siempre a tu disposición. Con un VPS Administrado, el soporte especializado está disponible las 24 horas,
                          los 7 días de la semana. Sin importar cuándo surja una pregunta, siempre habrá una respuesta.<br></br><br></br>
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image3} alt="VPS gestionado en Colombia" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Adaptado a tus necesidades en Colombia
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Para quienes están en Colombia, la opción de VPS Administrado significa beneficios adicionales. La gestión localizada garantiza
                          tiempos de carga rápidos y una conexión confiable, mejorando significativamente la experiencia del usuario.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image4} alt="Recursos garantizados" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Recursos garantizados
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Garantizamos que tus recursos, desde potencia de procesamiento hasta almacenamiento, sean dedicados y exclusivos.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image5} alt="Aprovisionamiento rápido" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Aprovisionamiento rápido
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Configuración y <Color1>entrega de servidores virtuales ultrarrápidas.</Color1><br></br><br></br>
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image6} alt="Protección DDoS" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Protección DDoS real
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Verdaderos servicios de protección DDOS de nivel empresarial respaldados por una enorme red de 150 GBPS para proteger
                          contra todos los ataques DDOS conocidos y de día cero.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                </Row>
              </Container>
            </ServiceContainer>
          </Section>
        )
    }

}

const Iconos = (props) => (
  <StaticQuery
      query={graphql`
      {          
        image1: file(relativePath: { eq: "icons/meeting.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image2: file(relativePath: { eq: "icons/soporte.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image3: file(relativePath: { eq: "icons/flagpoint.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image4: file(relativePath: { eq: "icons/cpu.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image5: file(relativePath: { eq: "icons/alarm.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image6: file(relativePath: { eq: "icons/ddos.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }        
      }
    `}
      render={(data) => {            
          const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
          const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
          const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
          const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
          const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
          const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);
          return <ServicesOne data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6}{...props} />;
      }}
  />
);

export default Iconos;
